import { makeApiActionCreatorV3 } from '@actions/utils';
import * as api from '../api/pinRetrievalRequests';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const prefix = 'PROCESS-MANAGER';

export const FETCH_PIN_RETRIEVAL_REQUESTS = createRequestTypes(
  `${prefix}/FETCH_PIN_RETRIEVAL_REQUESTS`,
);

export const fetchPINRetrievalRequests = makeApiActionCreatorV3(
  api.fetchPINRetrievalRequests,
  FETCH_PIN_RETRIEVAL_REQUESTS[START],
  FETCH_PIN_RETRIEVAL_REQUESTS[SUCCESS],
  FETCH_PIN_RETRIEVAL_REQUESTS[ERROR],
);

export const FETCH_PIN_RETRIEVAL_REQUEST_DETATILS = createRequestTypes(
  `${prefix}/FETCH_PIN_RETRIEVAL_REQUEST_DETATILS`,
);

export const fetchPINRetrievalRequestDetails = makeApiActionCreatorV3(
  api.fetchPINRetrievalRequestDetails,
  FETCH_PIN_RETRIEVAL_REQUEST_DETATILS[START],
  FETCH_PIN_RETRIEVAL_REQUEST_DETATILS[SUCCESS],
  FETCH_PIN_RETRIEVAL_REQUEST_DETATILS[ERROR],
);

export const CREATE_NEW_PIN_RETRIEVAL_REQUESTS = createRequestTypes(
  `${prefix}/CREATE_NEW_PIN_RETRIEVAL_REQUESTS`,
);

export const createNewPINRetrievalRequests = makeApiActionCreatorV3(
  api.createNewPINRetrievalRequests,
  CREATE_NEW_PIN_RETRIEVAL_REQUESTS[START],
  CREATE_NEW_PIN_RETRIEVAL_REQUESTS[SUCCESS],
  CREATE_NEW_PIN_RETRIEVAL_REQUESTS[ERROR],
);

export const FETCH_PENDING_RETRIEVAL_REQUESTS_COUNT = createRequestTypes(
  `${prefix}/FETCH_PENDING_RETRIEVAL_REQUESTS_COUNT`,
);

export const fetchPendingRetrievalRequestsCount = makeApiActionCreatorV3(
  api.fetchPendingRetrievalRequestsCount,
  FETCH_PENDING_RETRIEVAL_REQUESTS_COUNT[START],
  FETCH_PENDING_RETRIEVAL_REQUESTS_COUNT[SUCCESS],
  FETCH_PENDING_RETRIEVAL_REQUESTS_COUNT[ERROR],
);

export const FETCH_PENDING_RETRIEVAL_REQUESTS = createRequestTypes(
  `${prefix}/FETCH_PENDING_RETRIEVAL_REQUESTS`,
);

export const fetchPendingRetrievalRequests = makeApiActionCreatorV3(
  api.fetchPendingRetrievalRequests,
  FETCH_PENDING_RETRIEVAL_REQUESTS[START],
  FETCH_PENDING_RETRIEVAL_REQUESTS[SUCCESS],
  FETCH_PENDING_RETRIEVAL_REQUESTS[ERROR],
);

export const FETCH_PIN_RETRIEVAL_REQUEST_CONFIGURATION = createRequestTypes(
  `${prefix}/FETCH_PIN_RETRIEVAL_REQUEST_CONFIGURATION`,
);

export const fetchPinRetrievalRequestConfiguration = makeApiActionCreatorV3(
  api.fetchPinRetrievalRequestConfiguration,
  FETCH_PIN_RETRIEVAL_REQUEST_CONFIGURATION[START],
  FETCH_PIN_RETRIEVAL_REQUEST_CONFIGURATION[SUCCESS],
  FETCH_PIN_RETRIEVAL_REQUEST_CONFIGURATION[ERROR],
);

export const UPDATE_PIN_RETRIEVAL_REQUEST_CONFIGURATION = createRequestTypes(
  `${prefix}/UPDATE_PIN_RETRIEVAL_REQUEST_CONFIGURATION`,
);

export const updatePinRetrievalRequestConfiguration = makeApiActionCreatorV3(
  api.updatePinRetrievalRequestConfiguration,
  UPDATE_PIN_RETRIEVAL_REQUEST_CONFIGURATION[START],
  UPDATE_PIN_RETRIEVAL_REQUEST_CONFIGURATION[SUCCESS],
  UPDATE_PIN_RETRIEVAL_REQUEST_CONFIGURATION[ERROR],
);